export default function OrderCheckoutSettings() {
    return (
        <div>
            order checkout settings
        </div>
    );
};